// src/AppWrapper.js
import React from 'react';
import App from './App';

const AppWrapper = () => (
  <App />
);

export default AppWrapper;
